import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=31b2fcee&scoped=true&"
import script from "./InputFile.vue?vue&type=script&lang=js&"
export * from "./InputFile.vue?vue&type=script&lang=js&"
import style0 from "./InputFile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InputFile.vue?vue&type=style&index=1&id=31b2fcee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b2fcee",
  null
  
)

export default component.exports